//cn.js

import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
  nav: {
    welcome1: 'International Conference on',
    welcome2: 'Cognitive Systems and Information Processing',
    date: 'December 25-27, 2020',
    address: 'Hengqin, Zhuhai, China',
    'tit-home': '主页',
    titOrganization: '主办单位',
    titCommittee: '组委会',
    titSubmissions: '论文征集 ',
    titProgram: '大会日程',
    titRegistration: '大会注册',
    titTravel: '旅游相关',
    titContact: '联系我们',
    titPlaceholder: '请选择',
    register: '意向登记'
  },
  head: {
    img: require('../../assets/img/fuzhou.jpg')
  },
  footer: {
    copyright: 'Copyright © ICCSIP 2022. All Rights Reserved.',
    message1:'公告',
    message2:'由于疫情原因，会议将延期至十一月。审稿结果将于9月26日之前邮件反馈',
    message3:'关闭'
  },
  home: {
    title: '欢迎参加  ICCSIP 2022',
    title1: '第七届认知系统与信息处理国际会议（ICCSIP）',
    title11:'12.17-18, 中国',
    // 
    content1:'认知系统与信息处理国际会议（ICCSIP）将于2022年12月17-18号在线上召开。本次会议旨在汇聚人工智能领域的近十名的院士，来自于世界各地的近五十名顶级人工智能专家和学者，近百名人工智能企业家，数十名投资人，共同探讨人工智能系统、认知系统和智能信息处理领域的最新进展，并展示新的研究成果和未来发展前景，并围绕人工智能技术的产业落地进行研讨和交流。',
    content2:'本次会议由中国人工智能学会、中国自动化学会、IEEE 计算智能学会主办， CAAI认知系统与信息处理专委会、中国自动化学会机器人智能专委会、福州大学承办。',
    // content12:'参 会 者 将 受 邀 参 加 2 0 2 2 全 球 人 工 智 能 产 品 应 用 博 览 会 、 人 工 智 能 领 域 菁 英 论 坛 、 机 器 人 挑 战 赛 等 。',
    // content13:'本 会 议 被 中 国 科 协 确 认 为 重 要 学 术 会 议 。',
      // 
    content3: '大会主办方：中国人工智能学会、中国自动化学会、IEEE 计算智能学会',
    content4: '承办方：CAAI认知系统与信息处理专委会、中国自动化学会认知计算与系统专委会、福州大学',
    content5: '协办方：即将公布 ...',
    content6:'支持方：即将公布 ...',
    title2: 'Important Dates',
    date1: 'Oct. 10, 2020"',
    desc1: 'Paper Submission Deadline',
    date2: 'Nov. 10, 2020"',
    desc2: 'Notification of Acceptance',
    date3: 'Dec. 10, 2020"',
    desc3: 'Author Registration'
  },
  submissions: {
    title1: '论文及分会主题征集',
    content1: '欢迎从多学科角度发表原创论文，主题领域包括，但不限于：',
    content2:
      '此外，ICCSIP 2022方案委员会还在会议的技术范围内征集特别会议的建议。特别会议将由国际公认的专家组织，目的是将研究人员聚集在一起，讨论特别的重点课题。提交给特别会议的论文将接受同行评审，评审标准与投稿论文相同。有兴趣组织特别会议的研究人员被邀请向ICCSIP 2022提交正式提案。特别会议提案应包括会议名称、范围和动机的简要描述、组织者的姓名、联系信息和简要的个人简历。',
    content3: '论文模板下载: ',
    content4: 'Microsoft Word',
    content5: 'LaTeX',
    'tit-cog': 'Cognitive Systems',
    'tit-info': 'Information Processing',
    papers: [
      {
        cog: 'Cognitive sciences and technology',
        info: 'Information presentation and metrics'
      },
      {
        cog: 'Visual cognition and computation',
        info: 'Multi-modal information interaction and fusion'
      },
      {
        cog: 'Auditory cognitive processing',
        info: 'Big data and intelligent information processing'
      },
      {
        cog: 'Tactile cognition and computation',
        info: 'Neural cognitive computation and learning'
      },
      {
        cog: 'Cognitive metrics',
        info: 'Visual information processing'
      },
      {
        cog: 'Cognitive psychology',
        info: 'Brain-computer interface'
      },
      {
        cog: 'Cognitive robotics',
        info: 'Bioinformatics and applications'
      },
      {
        cog: 'Cognitive radio',
        info: 'Multi-modal cognitive mechanism for dexterous operation'
      },
      {
        cog: 'Cognitive radars',
        info: 'Extreme learning / other learning machines  and applications'
      }
    ],
    title2: ' 论文提交',
    content6: '请将论文发送到: ',
    submit2: '即将公布 ...',
    content7: "如果您还没有easychair账户, 请先注册一个:",
    signupat: '即将公布 ...',
    content8:
      '请作者在投稿截止日期前通过在线投稿系统提交长篇论文（不少于12页）。同时邀请潜在的组织者征集5篇以上主题一致的论文，组成专题会议。提交的论文意味着该论文是原创的，且未提交过审稿，或在其他地方未受版权保护，如被录用，将由一名作者发表。所有提交的论文将由该领域的专家根据原创性、重要性、质量和清晰度等标准进行评审。被录用的论文作者将有机会对论文进行修改，并考虑评委的意见和建议。在ICCSIP 2022上发表的论文将发表在EI索引的论文集上，部分入选的顶级论文将被收录在一些SCI索引期刊的特刊上。',
    content9:
      "The submitted paper implies that it is original and has not been submitted under review or is not copyright-protected elsewhere and will be presented by an author if accepted. All submitted papers will be refereed by experts in the field based on the criteria of originality, significance, quality, and clarity. The authors of accepted papers will have an opportunity to revise their papers and take consideration of the referees' comments and suggestions.",
    content10:
      '在ICCSIP 2022上发表的论文将发表在EI索引的论文集上，部分入选的顶级论文将被收录在一些SCI索引期刊的特刊上。',
    'journal-title': '期刊杂志',
    journals: [
      'Cognitive Computation and Systems',
      'International Journal of Control, Automation, and Systems',
      'Robotics and Autonomous Systems',
      'Science China: Information Sciences',
      'Tsinghua Science and Technology (English Version)',
      'IEEE Transactions on Cognitive and Development Systems',
      'IEEE Transactions on Fuzzy Systems'
    ],
    dates: [
      {
        process: '论文截止日期',
        date: '2022年10月10日'
      },
      {
        process: '录用通知时间',
        date: '2022年10月30日'
      },
      {
        process: '参会登记时间',
        date: '2022年11月10日'
      }
    ],
    title3: '重要时间节点'
  },
  organization: {
    title1: '福州大学',
    title1description1: '福州大学是国家“双一流”建设高校、国家“211工程”重点建设大学、福建省人民政府与国家教育部共建高校。学校创建于1958年，现已发展成为一所以工为主、理工结合，理、工、经、管、文、法、艺等多学科协调发展的重点大学。',
    title1description2: '建校以来，一代代福大人秉承“明德至诚，博学远志”校训，践行以张孤梅同志为代表的艰苦奋斗的创业精神、以卢嘉锡先生为代表的严谨求实的治学精神、以魏可镁院士为代表的勇于拼搏的奉献精神等“三种精神”，营造“守正创新、彰显特色、开放包容、追求卓越” 的新时代福州大学校园文化，积累了丰富的办学经验，形成了鲜明的办学特色，已为国家培养了全日制毕业生29万余人。',
    title1description3: '学校设有27个学院（含1个独立学院和1个中外合作办学学院），现有在校普通本科学生38427人，其中，至诚学院学生13185人；各类博、硕士研究生14358人。学校现设90个本科专业；38个一级学科硕士点、21个硕士专业学位授权点；14个一级学科博士点，2个专业学位博士点，10个博士后科研流动站。学校拥有1个国家重点学科、1个国家重点(培育)学科，化学学科再次入选世界一流学科建设名单。6个学科进入ESI学科全球排名前1%，其中化学学科进入ESI学科全球排名前1‰。学校综合实力在“2021软科世界大学学术排名”位居全球第396名，内地高校56名；在USNews2022世界大学排行榜位居全球第619名，内地高校第57名；在2021泰晤士高等教育世界大学排名位居全球第801-1000名，内地高校第57名；在2021QS亚洲大学排名位居第261-270名，内地高校并列66名。',
    title1description4: '学校现有教职工3229人，其中专任教师2186人。共有省级以上高层次人才634人次，其中国家级人才112人次（71人）、省级人才522人次（353人）。在高层次人才（团队）中，拥有院士15人（含特聘讲席教授14人），“长江学者奖励计划”人选10人（含青年项目3人），国家级高层次引进人才23人（含青年项目20人），国家“万人计划”入选者14人（含青年项目2人），国家杰出青年科学基金获得者8人，全国杰出专业技术人才1人，“百千万人才工程”国家级人选12人，国家有突出贡献中青年专家9人，国家优秀青年科学基金获得者4人，国家自然科学基金优秀青年科学基金项目（海外）获得者3人，科技部中青年科技创新领军人才及重点领域创新团队负责人7人，教育部创新团队负责人3人，文化名家暨“四个一批”人才3人。1支团队入选“全国专业技术人才先进集体”，2支团队入选“全国高校黄大年式教师团队”，2支团队入选教育部“长江学者和创新团队发展计划”，2支团队入选科技部“创新人才推进计划”重点领域创新团队，1个学院入选国家“高校国际化示范学院推进计划”，2个学院入选国家“高等学校学科创新引智计划”(“111计划”)。',
    title1description5: '学校拥有2个国家级人才培养基地、6个国家级实验教学示范中心、1个国家虚拟仿真实验教学中心、1个国家人才培养模式创新实验区、6个校企合作的国家工程实践教育中心、1个全国工程专业学位研究生联合培养示范基地、1个教育部首批“三全育人”综合改革试点院（系），1个教育部基础学科拔尖学生培养计划2.0基地，1个国家教学团队，7个国家特色专业，27个国家一流本科专业建设点，15个专业通过教育部工程教育专业认证，2个专业通过住建部行业评估，获评25门国家一流本科课程、3门国家精品课程、1门国家双语教学示范课程、3门国家级精品资源共享课、2门国家级精品视频公开课、4个国家虚拟仿真实验教学项目、7个教育部“新工科”研究与实践项目，4个教育部“新文科”研究与改革实践项目，获批教育部课程思政示范课程1门、国家级课程思政示范教学团队1个、全国思政课程教学名师工作室1个，入选高等学校思想政治理论课教学指导委员会委员1人、省级课程思政研究与实践中心1个、省级课程思政示范课程2门。学校是全国专业学位研究生教育综合改革试点单位和全国工程硕士研究生教育创新高校、教育部“卓越工程师教育培养计划”改革试点高校和教育部“国家大学生创新创业训练计划”实施高校。“十三五”以来，学校获国家级教学成果奖4项，省级教学成果奖26项；学生参加各类学科竞赛获246项国际奖，2112项国家级奖。学校入选“全国首批深化创新创业教育改革示范高校”“国家级众创空间”“国家大学生创业示范园”。在前七届中国“互联网+”大学生创新创业全国总决赛中获9金18银25铜。学校毕业生就业率连续多年保持在95%以上，曾荣获“全国高校毕业生就业工作50强”。',
    title1description6: '学校现有1个国家级大学科技园，12个国家级、131个省部级科技创新平台，其中：1个国家重点实验室，8个国家级工程研究中心，3个国家国际科技合作基地，3个教育部重点实验室，1个教育部工程研究中心，2个省部共建协同创新中心，1个自然资源部创新服务平台，2个省创新实验室。学校是福建省唯一同时拥有“国家大学科技园”“国家技术转移示范机构”“高等学校科技成果转化和技术转移基地”“国家知识产权试点高校” “国家级众创空间”“全国大学生创业示范园”“全国深化创新创业教育改革示范高校”“全国创业孵化示范基地”的高校。“十三五”以来，学校获各类科技项目4757项，科研经费超过18.2亿元。签订横向合作合同3294项，校地企合作到校经费15.4亿元。获省部级以上奖项243项，其中，国家科技奖4项。获国家专利授权5320件，科技论文被三大检索收录12618篇，其中在Nature期刊发表论文2篇。9位学者入选2021年“全球高被引科学家”名单。',
    title1description7: '学校深入开展对外合作交流，与清华大学、北京大学、中国人民大学、天津大学、中国科学院海西研究院以及境外50个国家、地区的140多所高校、科研机构和知名企业建立了合作关系。学校积极对接国家“一带一路”倡议，建立国际科教合作交流平台，成为中国政府奖学金留学生接收院校，面向30余个国家招收来华留学生；学生出国（境）访学项目覆盖95%以上的学院；聘请50余名海外专家学者长期在校任教。学校现有1个中外合作办学机构——梅努斯国际工程学院，3个中外合作办学项目，涵盖本科和研究生层次。学校现为闽台合作办学国家改革试点重点项目单位，对台交流合作向纵深发展,成建制双向联合培养模式成为闽台教育交流合作的新亮点。',
    title1description8: '学校校园环境优美、教学和科研设备先进、公共服务体系完善，不断推进文化校园、智慧校园和生态校园建设。办学主体位于旗山校区，在福州、厦门以及泉州等地拥有多个校区，校舍建筑面积163万平方米。学校固定资产总值超54亿元，其中教学科研仪器设备值19.8亿元；运动场地总面积20万平方米；图书馆藏图书362万册，电子图书585万册。',
    title1description9: '学校正朝着“建成具有若干世界一流学科的国际知名高水平大学，早日成为世界一流的东南强校”的宏伟目标大步迈进，努力为国家和区域经济社会发展作出新的更大贡献！',
    title1description10: '（数据统计截至2022年2月）',
    // type1: '主办方',
    type1: '即将公布 ...',
    name1: '中国人工智能学会',
    name2: '中国自动化学会',
    name3: 'IEEE计算智能学会',
    type2: '承办方',
    name30:'CAAI认知系统与信息处理专委会',
    name31:'中国自动化学会认知计算与系统专委会',
    name4: '清华大学',
    name5: '材料科学姑苏实验室',
    type3: '协办方',  
    name6: '南京清湛人工智能研究院',
    name7: '中国电子信息产业发展研究院',
    name8: '中科融合感知智能研究院',
    type4:'支持方',
    name9: '英伟达-英迈',
    title2: '大会组委会',
    committee: {
      名誉主席: [{name:' 张钹, 中国',img:require('../../assets/img/zhangbo.jpg'),position:"中国科学院院士",position1:"清华大学人工智能研究院院长",position2:"2014年度CCF终身成就奖",experience:"计算机科学与技术专家，俄罗斯自然科学院外籍院士、中国科学院院士、清华大学教授、博士生导师。现任清华大学人工智能研究院院长。2015年获得2014年度CCF终身成就奖。2019年获得吴文俊人工智能最高成就奖。从事人工智能理论、人工神经网络、遗传算法、分形和小波等理论研究；以及把上述理论应用于模式识别、知识工程、智能机器人与智能控制等领域的应用技术研究"},
      {name:'郑南宁, 中国',img:require('../../assets/img/组委会/郑南宁.jpg'),position:"中国工程院院士",position1:"中国自动化学会理事长",position2:"IEEE Fellow",experience:"郑南宁建立的视觉场景理解的立体对应计算模型与视觉注意力统计学习方法成为该领域代表性工作，为构造计算机视觉系统和基于图像信息的智能控制系统，提供了理论指导和关键技术，提出图像分析和视觉知识描述新方法，为构造计算机视觉系统和基于图像信息的智能控制系统，提供了理论指导和关键技术。完成了“精密装配机器人机器视觉系统”研究。发明了一种图像边缘曲线拟合的新方法。完成了“高性能机器视觉及车型与牌照自动识别系统。提出在线交互式立体测深方法，研制出“X线数字减影血管造影系统”及“DSA1250数字减影血管造影系统”。研制出具有自主知识产权的数字电视扫描制式转换及视频处理芯片。"},
      {name:'李德毅, 中国',img:require('../../assets/img/组委会/李德毅.jpg'),position:"中国工程院院士",position1:"中国人工智能学会名誉理事长",position2:"",experience:"长期从事计算机工程、不确定性人工智能、大数据和智能驾驶领域研究。最早提出“控制流-数据流”图对理论，证明了关系数据库模式和谓词逻辑的对等性。提出云模型、云变换、数据场等认知形式化理论，用于解决定性概念生成、相似度计算、不确定推理、智能控制等问题，成功控制三级倒立摆各种动平衡的姿态。提出基于路权构建驾驶态势认知图，研发机器驾驶脑。"},
      ],
      顾问委员会主席: [
        {name:'戴琼海，中国',img:require('../../assets/img/组委会/戴琼海.png'),position:"中国工程院院士",position1:"中国人工智能学会理事长",position2:'清华大学信息学院院长',experience:"北京信息科学与技术国家研究中心主任，2005年国家自然科学基金委杰出青年基金获得者，2009年受聘教育部“长江学者奖励计划”特聘教授，2017全国创新争先奖状获得者，2017年当选中国工程院院士。主要学术方向为人工智能（立体视觉）和计算摄像学，长期致力于该研究领域的理论和关键技术创新，主持承担了科技部重大基础研究973项目和国家基金委重大仪器项目，成功研制了多维多尺度计算摄像仪器，并有望成为脑科学和肿瘤转移研究的重要利器。分别获得2016年国家科技进步二等奖、2012年国家技术发明一等奖和2008年国家技术发明二等奖。"},
        {name:'任福继，中国',img:require('../../assets/img/组委会/任继福.png'),position:"日本工程院院士",position1:"德岛大学教授",position2:'情感计算与智能机器人实验室主任',experience:""},
        // {name:'张建伟，德国',img:require('../../assets/img/组委会/张建伟.jpg'),position:"德国汉堡大学信息学科学系教授",position1:"多模态技术研究所所长",position2:"德国汉堡科学院院士长",experience:""},
        {name:'胡事民, 中国',img:require('../../assets/img/组委会/胡世民.jpg'),position:"清华大学教授",position1:"国家自然科学基金委创新群体项目学术带头人",experience:"清华大学计算机科学与技术系教授，国家自然科学基金委创新群体项目学术带头人，中国计算机学会副理事长，Computational Visual Media（Springer）主编，亚洲图形学协会主席"},
        // {name:'杨辉，中国',img:require('../../assets/img/组委会/杨辉.jpg'),position:"博士生导师",position1:"国家杰出青年基金获得者",position2:'材料科学姑苏实验室执行主任',experience:"曾任中科院苏州纳米所所长。国家杰出青年基金获得者，江苏省政协委员，江苏省科协副主席，享受政府特殊津贴，曾荣获中科院青年科学家奖、“863”先进工作者、“十一五”国家科技计划执行突出贡献奖、苏州市科技创新创业市长奖等。"},
      ],
      大会主席: [
        {name:'孙富春，中国',img:require('../../assets/img/组委会/孙富春.jpg'),position:"清华大学教授,博士生导师",position1:'IEEE/CAAI/CAA Fellow',position2:'国家杰出青年基金获得者',experience:"国家杰出青年基金获得者;兼任清华大学校学术委员会委员，计算机科学与技术系学术委员会主任，智能技术与系统国家重点实验室常务副主任。兼任担任国家重点研发计划机器人总体专家组成员，中国人工智能学会副理事长，中国自动化学会和中国认知科学学会常务理事"},
        {name:'Angelo Cangosi, 英国',img:require('../../assets/img/组委会/Angelo.png'),position:"英国曼彻斯特大学的机器学习和机器人学教授",position1:'艾伦-图灵研究所的研究员',experience:"Angelo是英国普利茅斯大学（Plymouth University）机器人和神经系统中心（Centre for Robotics and Neural Systems）的人工智能和认知教授和创始主任。IEEE Transactions on Autonomous Development的主编。他的最新著作《发育机器人学。从婴儿到机器人》（麻省理工学院出版社；与马特-施莱辛格合著）于2015年1月出版，最近被翻译成中文和日文。"},
        {name:'张建伟，德国',img:require('../../assets/img/组委会/张建伟.jpg'),position:"德国汉堡大学信息学科学系教授",position1:"多模态技术研究所所长",position2:"德国汉堡科学院院士长",experience:""},
        {name:'陈国龙，中国',img:require('../../assets/img/组委会/陈国龙.jpg'),position:"福州大学计算机与大数据学院教授",position1:"福建省人工智能学会副理事长",position2:'福州大学党委书记',experience:""},
      ],
      // 区域大会主席: [
      //   {name:'Jonathan Garibaldi, 英国', position:""},
      //   {name:'Katharina Rohlfing, 德国', position:""},
      // ],
      程序委员会主席:[
        {name:'胡德文 中国',position:"国防科技大学"},
        {name:'郭文忠 中国', position:"福州大学"},
        {name:'Stefan Wermter 德国', position:"汉堡大学"},
        // {name:'Xin Yao, 英国',position:""},
        // {name:'杨磊 中国',position:"清湛人工智能研究院"},
        {name:"刘华平 中国",position:"清华大学副教授,博士生导师,国家杰出青年基金获得者"}
      ],
      // 区域程序主席:[
      //   {name:"刘华平 中国",position:"清华大学"},
      //   {name:"Antonio Chella, 意大利",position:""},
      //   {name:'黄广斌, 新加坡',position:"南洋理工大学"},
      //   {name:"Chenguang Yang, 英国",position:""},
      // ],
      出版主席:[
        {name:"方斌 中国",position:"清华大学"},
        // {name:"常峰 中国",position:"硅步智能"},
        // {name:"方承 丹麦",position:"南丹麦大学"},
        // {name:"俞玉树 中国",position:"北京理工大学"},
        // {name:"曹勇 中国",position:"西北工业大学"},
        // {name:"董明杰 中国",position:"北京工业大学"},
      ],
      // 程序委员会:[
      //   {name:'杨辰光,  英国',position:"西英格兰大学"},
      //   {name:'黄广斌,  新加坡',position:"南洋理工大学"},
      //   {name:'Katharina Rohlfing,  德国',position:"帕德伯恩大学"},
      //   {name:'Antonio Chella,  意大利',position:"巴勒莫研究大学"},
      //
      //   // {name:"方斌 中国",position:"清华大学"},
      //   // {name:'Antonio Chella,  意大利',position:"巴勒莫研究大学"},
      //   // {name:"万伟伟 日本",position:"大阪大学"},
      //   // {name:"匡邵龙 中国",position:"深圳技术大学"},
      //   // {name:"李海源 中国",position:"北京邮电大学"},
      // ],
      // 本地组织主席:[
      //   {name:"于元隆 中国",position:"福州大学"},
      //   {name:"郑清海 中国",position:"福州大学"},
      //   {name:"邓震 中国",position:"福州大学"},
      // ],

    },
    
    committee2:{
      程序委员会: [
        {name:'杨辰光,  英国',position:"西英格兰大学"},
        {name:'黄广斌,  新加坡',position:"南洋理工大学"},
        {name:'Katharina Rohlfing,  德国',position:"帕德伯恩大学"},
        {name:'Antonio Chella,  意大利',position:"巴勒莫研究大学"},
        {name:'郝雨飞 瑞士',position:"EPFL"},
        {name:'邓震 中国',position:"福州大学"},
        {name:'任军 中国',position:"湖北工业大学"},
        {name:'刘春芳 中国',position:"北京工业大学"},
        {name:'李长胜 中国',position:"北京理工学院"},
        {name:'董明杰 中国',position:"北京航空航天大学"},
        // {name:'苏鹏 中国',position:"北京信息科技大学"},
        {name:'黄瑞 中国',position:"中国电子科技大学"},
        {name:'刘甜 中国',position:"北京信息科技大学"},
        {name:'李海源 中国',position:"北京邮电大学"},
        {name:'曹勇 中国',position:"西北工业大学"},
        {name:'侯涛刚 中国',position:"北京交通大学"},
    ],
  }

  },
  Program: {
    title: '大会日程一览',
    // title: '即将公布 ...',
    src1: require('../../assets/img/program1.png'),
    src2: require('../../assets/img/program2a.png'),
    src3: require('../../assets/img/program2b.png'),
    src4: require('../../assets/img/program3.png')
  },
  Registration: {
    // title: '注册参会须知（论文作者和普通参会者）',
    title: '即将公布 ...',
    content1: '会议注册费：2600元，',
    content2: '2600元',
    content3: '汇款至如下账号，汇款时',
    content33:'必须',
    content333:'备注',
    content4: '"ICCSIP",姓名和文章id号;',
    content44:'无参会论文者',
    content444:',汇款时',
    content4444:'ICCSIP、姓名、无论文',
    content5: '；以便认领查询。',
    timestamp1: '1) 直接汇款',
    timestamp2: '2) 支付宝转账',
    organization: '单位名称: 中国人工智能学会',
    bank: '银行: 中国工商银行新街口支行',
    account: '账号: 0200002909200166203',
    content6: '填写附件的',
    content7: '会议注册表和同意出版表',
    content8: '并发送邮件至',
    content9: 'iccsip2022@163.com',
    content10: '',
    content11: '中文公告: ',
    content12: 'ICCSIP2022会议通知'
  },
  Travel: {
    url:'http://119.45.41.168:9000/profile/other/cn.pdf',
    title: '历史文化',
    content1:
      '苏州是中国第一批“文化历史名城”之一，也是重要的风景名胜城市，自吴王阖闾建立这座城市以来，已有2500多年的历史.',
    content11:'吴侬软语的苏州，坐落在水网之中，街道依河而建，建筑临水而居，前巷后河，一幅小桥流水人家的水墨画。苏州既有园林之美，又富山水之胜，苏州园林几乎成了苏州的代名词，到苏州不游上几个诸如拙政园、留园的园子总是说不过去的。而姑苏城外的太湖风光，一个个极富江南韵致的水乡古镇又让苏州多了一份水的灵动。',
    content12:'《世界文化遗产名录》中列出了苏州的9个古典园林和大运河的苏州段。',
    content13:'《联合国人类非物质文化遗产代表作名录》列出了中国昆曲，中国古琴艺术等6个项目。',
    content14:'作为历史上几代天才的摇篮，苏州拥有众多名人。来自苏州的历史上共有51名文职和军事第一学者，中科院和中国工程院的121名院士，因此苏州被誉为著名的“学者之乡”和“院士之乡”。',
    timeline1:
      'Portugal claimed both Xiao Hengqin and Da Hengqin, along with the larger former island of Wanzai — now a peninsula — to their north, as part of the Macau. Portugal briefly occupied them before World War II.',
    timeline2: 'The two islands, Xiao Hengqin and Da Hengqin, were reclaimed into one island, which is now Hengqin Island.',
    timeline3: 'The Chinese government resumed the exercise of sovereignty over Macau, and the ',
    timeline4: "Macau Special Administrative Region of the People's Republic of China",
    timeline5: 'was established.',
    timeline6: 'The government of Macau officially announced that the',
    timeline7: 'University of Macau',
    timeline8: 'would build its new campus on the island.',
    timeline9: 'The State Council of China approves the establishment of ',
    timeline10: 'Hengqin New Area',
    timeline11: '.',
    title2: '交通与旅游',
    desc1:
      '苏州距离苏南硕放机场仅40分钟车程，距离上海虹桥机场也仅1小时左右车程。市内共有3个火车站和3个客运站，同时地铁线路覆盖全市，出行十分方便',
    tip1: ' ',
    tip11:' 苏州属于亚热带气候，当地气候温和湿润，而且四季分明。因此随着季节的变化，苏州园林有时花团锦簇，时而又绿树浓荫，有时又会银装素裹，将千姿百态的美景展现在游客的面前。',
    tip12:'“到苏州不游虎丘，乃憾事也”，因此虎丘是旅游者到苏州的必游之地，是苏州历史文化名城的标志。',
    tip13:' 苏州市的住宿条件较好，设施齐备，但是游客旅游仍需出发前提前预定房间。',
    tip14:' 游苏州园林或者是探访水乡古镇，建议避开双休日和节假日。只有在人少的时候，才能真正体味苏州这座古城独特的韵味.',
    tip15:' 苏州的景点基本都在17：30以前就关门了，请合理安排时间。',
    tip16:' 苏州的有名美食有哑巴生煎、采芝斋、松鹤楼菜馆、寒山寺素菜馆、苏式面条等，可以在游玩的过程中慢慢品尝',
    tip17:' 苏绣是苏州最著名的旅游纪念品之一，苏州的碧螺春茶是中国的十大名茶之一。',
    tipMore:'更多旅游攻略请点这里。',
    tip2: 'By Sea: ',
    tip3: 'By Land: ',
    desc2:
      'There are 5 international and domestic airports around Hengqin: Hong Kong International Airport, Macau International Airport, Guangzhou International Airport, Shenzhen International Airport, and Zhuhai Airport.',
    desc3:
      'There are 3 large ports around Hengqin: Wan Chai Pier, Kyushu Port and Shenzhen Shekou Port. Hengqin Passenger Terminal has just opened.',
    desc4: 'From downtown Zhuhai, Hengqin can be reached by multiple highways and bus lines.',
    desc5:
      'Hengqin Island got its name because of its shape like Guqin. It has a natural landscape of ten steps and one waterfall and hundreds of steps and trees.',
    desc6:
      'The remains of the naval battles of the Song and Yuan armies in ancient times are still preserved, and there are also Tianhu Scenic Area, Triassic Spring, Ocean Paradise, Shibo Garden and other scenic spots.',
    desc7:
      'It is close to Macau and is a new city with a little landscape, suitable for entertainment and shopping. In addition, it is also a famous oyster eating spot in Zhuhai.'
  },
  Contact: {
    title1: '联系方式',
    // title1: '即将公布 ...',
    contacts: [
      {
        item: '联系方式',
        active:"人工智能与认知智能国际大会通知请关注",
        content: '联系邮箱： iccsip2022@163.com',
        content11:'招商负责人：<br></br>陈雨馨<br></br> +86 13301585615<br></br>xxxxxxxx@163.com',
        icon: 'el-icon-user',
        type: 'primary',
        img:"https://bushantest.oss-cn-hangzhou.aliyuncs.com/tsingzhan.jpg"
      },
      // {
      //   item: '邮箱',
      //   content: 'iccsip2022@163.com',
      //   content11:'tsingzhan@163.com',
      //   icon: 'el-icon-message',
      //   type: 'danger',
      //   img:""
      // },
      // {
      //   item: '电话',
      //   content: '孙倩怡：+86 15952525480',
      //   content11:'王茗轩：+86 15323399997',
      //   icon: 'el-icon-phone-outline',
      //   type: 'warning',
      //   img:""

      // },
      // {
      //   item: '微信公众号',
      //   content: '认知系统与信息处理专委会',
      //   img:"https://bushantest.oss-cn-hangzhou.aliyuncs.com/tsingzhan.jpg",
      //   icon: 'el-icon-chat-round',
      //   type: 'success'
      // }
    ]
  },
  Reginst:{
    phone:"手机号:",
    spectators:"公司:",
    characters:'您的身份:',
    checkphone:'验证码：',
    content:"温馨提示：所有注册用户均有资格参与抽奖，奖品包括ipad、华为手机、jetson nano开发板，更有机会获得免费苏杭旅游。",
    type1:'论文作者',
    type2:'参会者',
    message11:'注册',
    message12:'重置',
    companyMessage:'请输入公司信息',
    message13:'',
    typeMessage:'请选择身份',
    CodeMessage:'发送验证码',
    PhoneErr1:'请勿重复注册',
    phoneErr2:'请输入手机号',
    phoneErr3:'请输入11位手机号',
  },
  ...zhLocale
}

export default cn
